/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import Button from '../../../components/Button'
import Toast from '../../../components/Toast/Toast'
import { IS_COMPANY, VIEWPORT_LG } from '../../../utils/constants'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { sendNpsInfo } from '../../../services/Nps'
import Loader from '../../../components/Loader'
import { TAGS } from '../../../services/Tags'
import { useGetProfileUserInfo } from '../../../hooks/useGetProfileUserInfo'
import Modal from '../../../components/Modal'
import { handleHideModal, handleOpenModal } from '../../../utils'
import useResize from '../../../hooks/useResize'

const LIST_OF_OPTIONS = [
  {
    id: 6,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M20.5 4H4.5C3.4 4 2.51 4.9 2.51 6L2.5 18C2.5 19.1 3.4 20 4.5 20H20.5C21.6 20 22.5 19.1 22.5 18V6C22.5 4.9 21.6 4 20.5 4ZM20.1 8.25L13.03 12.67C12.71 12.87 12.29 12.87 11.97 12.67L4.9 8.25C4.79973 8.19371 4.71192 8.11766 4.64189 8.02645C4.57186 7.93525 4.52106 7.83078 4.49258 7.71937C4.46409 7.60796 4.4585 7.49194 4.47616 7.37831C4.49381 7.26468 4.53434 7.15581 4.59528 7.0583C4.65623 6.96079 4.73632 6.87666 4.83073 6.811C4.92513 6.74533 5.03187 6.69951 5.1445 6.6763C5.25712 6.65309 5.37328 6.65297 5.48595 6.67595C5.59863 6.69893 5.70546 6.74453 5.8 6.81L12.5 11L19.2 6.81C19.2945 6.74453 19.4014 6.69893 19.514 6.67595C19.6267 6.65297 19.7429 6.65309 19.8555 6.6763C19.9681 6.69951 20.0749 6.74533 20.1693 6.811C20.2637 6.87666 20.3438 6.96079 20.4047 7.0583C20.4657 7.15581 20.5062 7.26468 20.5238 7.37831C20.5415 7.49194 20.5359 7.60796 20.5074 7.71937C20.4789 7.83078 20.4281 7.93525 20.3581 8.02645C20.2881 8.11766 20.2003 8.19371 20.1 8.25Z"
          fill="#004949"
        />
      </svg>
    ),
    text: 'Correo',
    value: 6,
  },
  {
    id: 1,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M13.528 2C14.653 2.003 15.224 2.009 15.717 2.023L15.911 2.03C16.135 2.038 16.356 2.048 16.623 2.06C17.687 2.11 18.413 2.278 19.05 2.525C19.71 2.779 20.266 3.123 20.822 3.678C21.3307 4.17773 21.7242 4.78247 21.975 5.45C22.222 6.087 22.39 6.813 22.44 7.878C22.452 8.144 22.462 8.365 22.47 8.59L22.476 8.784C22.491 9.276 22.497 9.847 22.499 10.972L22.5 11.718V13.028C22.5025 13.7574 22.4948 14.4868 22.477 15.216L22.471 15.41C22.463 15.635 22.453 15.856 22.441 16.122C22.391 17.187 22.221 17.912 21.975 18.55C21.7242 19.2175 21.3307 19.8223 20.822 20.322C20.3223 20.8307 19.7175 21.2242 19.05 21.475C18.413 21.722 17.687 21.89 16.623 21.94L15.911 21.97L15.717 21.976C15.224 21.99 14.653 21.997 13.528 21.999L12.782 22H11.473C10.7433 22.0026 10.0135 21.9949 9.28402 21.977L9.09002 21.971C8.85263 21.962 8.61529 21.9517 8.37802 21.94C7.31402 21.89 6.58802 21.722 5.95002 21.475C5.28285 21.2241 4.67846 20.8306 4.17902 20.322C3.66996 19.8224 3.27613 19.2176 3.02502 18.55C2.77802 17.913 2.61002 17.187 2.56002 16.122L2.53002 15.41L2.52502 15.216C2.50659 14.4868 2.49825 13.7574 2.50002 13.028V10.972C2.49725 10.2426 2.50459 9.5132 2.52202 8.784L2.52902 8.59C2.53702 8.365 2.54702 8.144 2.55902 7.878C2.60902 6.813 2.77702 6.088 3.02402 5.45C3.27571 4.7822 3.67024 4.17744 4.18002 3.678C4.67917 3.16955 5.28321 2.77607 5.95002 2.525C6.58802 2.278 7.31302 2.11 8.37802 2.06C8.64402 2.048 8.86602 2.038 9.09002 2.03L9.28402 2.024C10.0132 2.00623 10.7426 1.99857 11.472 2.001L13.528 2ZM12.5 7C11.1739 7 9.90217 7.52678 8.96449 8.46447C8.0268 9.40215 7.50002 10.6739 7.50002 12C7.50002 13.3261 8.0268 14.5979 8.96449 15.5355C9.90217 16.4732 11.1739 17 12.5 17C13.8261 17 15.0979 16.4732 16.0356 15.5355C16.9732 14.5979 17.5 13.3261 17.5 12C17.5 10.6739 16.9732 9.40215 16.0356 8.46447C15.0979 7.52678 13.8261 7 12.5 7ZM12.5 9C12.894 8.99993 13.2841 9.07747 13.6481 9.22817C14.0121 9.37887 14.3429 9.5998 14.6215 9.87833C14.9001 10.1569 15.1211 10.4875 15.272 10.8515C15.4228 11.2154 15.5005 11.6055 15.5005 11.9995C15.5006 12.3935 15.4231 12.7836 15.2723 13.1476C15.1216 13.5116 14.9007 13.8423 14.6222 14.121C14.3437 14.3996 14.013 14.6206 13.649 14.7714C13.2851 14.9223 12.895 14.9999 12.501 15C11.7054 15 10.9423 14.6839 10.3797 14.1213C9.81709 13.5587 9.50102 12.7956 9.50102 12C9.50102 11.2044 9.81709 10.4413 10.3797 9.87868C10.9423 9.31607 11.7054 9 12.501 9M17.751 5.5C17.4195 5.5 17.1016 5.6317 16.8671 5.86612C16.6327 6.10054 16.501 6.41848 16.501 6.75C16.501 7.08152 16.6327 7.39946 16.8671 7.63388C17.1016 7.8683 17.4195 8 17.751 8C18.0825 8 18.4005 7.8683 18.6349 7.63388C18.8693 7.39946 19.001 7.08152 19.001 6.75C19.001 6.41848 18.8693 6.10054 18.6349 5.86612C18.4005 5.6317 18.0825 5.5 17.751 5.5Z"
          fill="#004949"
        />
      </svg>
    ),
    text: 'Instagram',
    value: 1,
  },
  {
    id: 2,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M17.5 1H3.5C2.4 1 1.5 1.9 1.5 3V17C1.5 18.101 2.4 19 3.5 19H10.5V12H8.5V9.525H10.5V7.475C10.5 5.311 11.712 3.791 14.266 3.791L16.069 3.793V6.398H14.872C13.878 6.398 13.5 7.144 13.5 7.836V9.526H16.068L15.5 12H13.5V19H17.5C18.6 19 19.5 18.101 19.5 17V3C19.5 1.9 18.6 1 17.5 1Z"
          fill="#004949"
        />
      </svg>
    ),
    text: 'Facebook',
    value: 2,
  },
  {
    id: 3,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M19 3C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19ZM18.5 18.5V13.2C18.5 12.3354 18.1565 11.5062 17.5452 10.8948C16.9338 10.2835 16.1046 9.94 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17C14.6813 12.17 15.0374 12.3175 15.2999 12.5801C15.5625 12.8426 15.71 13.1987 15.71 13.57V18.5H18.5ZM6.88 8.56C7.32556 8.56 7.75288 8.383 8.06794 8.06794C8.383 7.75288 8.56 7.32556 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19C6.43178 5.19 6.00193 5.36805 5.68499 5.68499C5.36805 6.00193 5.19 6.43178 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56ZM8.27 18.5V10.13H5.5V18.5H8.27Z"
          fill="#004949"
        />
      </svg>
    ),
    text: 'Linkedin',
    value: 3,
  },
  {
    id: 4,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M12.5 14.475L14.425 15.625C14.6083 15.7417 14.7877 15.7377 14.963 15.613C15.1383 15.4883 15.2007 15.3173 15.15 15.1L14.65 12.925L16.35 11.45C16.5167 11.3 16.5667 11.121 16.5 10.913C16.4333 10.705 16.2833 10.5923 16.05 10.575L13.825 10.4L12.95 8.325C12.8667 8.125 12.7167 8.025 12.5 8.025C12.2833 8.025 12.1333 8.125 12.05 8.325L11.175 10.4L8.95 10.575C8.71667 10.5917 8.56667 10.7043 8.5 10.913C8.43333 11.1217 8.48333 11.3007 8.65 11.45L10.35 12.925L9.85 15.1C9.8 15.3167 9.86267 15.4877 10.038 15.613C10.2133 15.7383 10.3923 15.7423 10.575 15.625L12.5 14.475ZM9.15 20H6.5C5.95 20 5.47933 19.8043 5.088 19.413C4.69667 19.0217 4.50067 18.5507 4.5 18V15.35L2.575 13.4C2.39167 13.2 2.25 12.9793 2.15 12.738C2.05 12.4967 2 12.2507 2 12C2 11.7493 2.05 11.5037 2.15 11.263C2.25 11.0223 2.39167 10.8013 2.575 10.6L4.5 8.65V6C4.5 5.45 4.696 4.97933 5.088 4.588C5.48 4.19667 5.95067 4.00067 6.5 4H9.15L11.1 2.075C11.3 1.89167 11.521 1.75 11.763 1.65C12.005 1.55 12.2507 1.5 12.5 1.5C12.7493 1.5 12.9953 1.55 13.238 1.65C13.4807 1.75 13.7013 1.89167 13.9 2.075L15.85 4H18.5C19.05 4 19.521 4.196 19.913 4.588C20.305 4.98 20.5007 5.45067 20.5 6V8.65L22.425 10.6C22.6083 10.8 22.75 11.021 22.85 11.263C22.95 11.505 23 11.7507 23 12C23 12.2493 22.95 12.4953 22.85 12.738C22.75 12.9807 22.6083 13.2013 22.425 13.4L20.5 15.35V18C20.5 18.55 20.3043 19.021 19.913 19.413C19.5217 19.805 19.0507 20.0007 18.5 20H15.85L13.9 21.925C13.7 22.1083 13.4793 22.25 13.238 22.35C12.9967 22.45 12.7507 22.5 12.5 22.5C12.2493 22.5 12.0037 22.45 11.763 22.35C11.5223 22.25 11.3013 22.1083 11.1 21.925L9.15 20Z"
          fill="#004949"
        />
      </svg>
    ),
    text: 'Recomendación',
    value: 4,
  },
  {
    id: 5,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_14044_381960)">
          <mask
            id="mask0_14044_381960"
            style={{
              maskType: 'luminance',
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path
              d="M11.3995 2.10048L2.20697 11.293C2.0195 11.4805 1.91418 11.7348 1.91418 12C1.91418 12.2651 2.0195 12.5194 2.20697 12.707L11.4 21.9C11.5875 22.0874 11.8418 22.1928 12.107 22.1928C12.3721 22.1928 12.6264 22.0874 12.814 21.9L22.0065 12.7075C22.1939 12.5199 22.2993 12.2656 22.2993 12.0005C22.2993 11.7353 22.1939 11.481 22.0065 11.2935L12.8135 2.09998C12.6259 1.91251 12.3716 1.80719 12.1065 1.80719C11.8413 1.80719 11.587 1.91251 11.3995 2.09998V2.10048Z"
              fill="white"
              stroke="white"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M9 12H15M12 9V15"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </mask>
          <g mask="url(#mask0_14044_381960)">
            <path d="M0 0H24V24H0V0Z" fill="#004949" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_14044_381960">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    text: 'Otro',
    value: 5,
  },
]

const NpsMessage = () => {
  const queryClient = useQueryClient()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const [showNpsMessage, setShowNpsMessage] = useState(true)
  const [currentValue, setCurrentValue] = useState(null)

  const { data: userData = {}, isLoading: userDataIsLoading } =
    useGetProfileUserInfo()

  //discovery_source_user

  const { mutate: sendNpsInfoMutate, isLoading: isLoadingSendNpsInfo } =
    useMutation(['send-nps-information'], sendNpsInfo, {
      onSuccess: ({ res }) => {
        if (res?.status === 200) {
          setShowNpsMessage(false)
          handleHideModal({ id: 'nps-modal' })
          Toast({ title: 'Información enviada correctamente.' })
          queryClient.invalidateQueries('send-nps-information')
        } else {
          Toast({ icon: 'error', title: 'Error en el sistema' })
        }
      },
    })

  return (
    <Modal renderModalHeader={false} modalId="nps-modal" modalSize="modal-sm">
      {userDataIsLoading ? (
        <Loader />
      ) : (
        <div
          style={{
            height: '320px',
          }}
          className="d-flex flex-column justify-content-between align-items-center py-2 px-4"
        >
          <span
            style={{
              fontSize: '24px',
            }}
            className="text-on-bg-primary"
          >
            ¿Cómo conociste Hutrit?
          </span>
          <div
            className="d-flex align-items-center gap-3 justify-content-lg-center mt-4 mb-4"
            style={{
              width: isMobile ? '100%' : '',
              overflow: isMobile ? 'auto' : '',
            }}
          >
            {LIST_OF_OPTIONS.map(({ icon, text, value, id }) => (
              <div className="d-flex flex-column align-items-center" key={id}>
                <div
                  className="bg-on-bg-Tertiary-hover rounded cursor-pointer d-flex align-items-lg-center justify-content-center"
                  style={{
                    width: '70px',
                    padding: '8px 16px',
                    opacity: value === currentValue ? '0.4' : '',
                  }}
                  onClick={() => {
                    setCurrentValue(value)
                  }}
                >
                  <div>{icon}</div>
                </div>
                <span
                  style={{
                    fontSize: '12px',
                  }}
                  className="text-on-bg-primary"
                >
                  {text}
                </span>
              </div>
            ))}
          </div>
          <Button
            onClick={() => {
              sendNpsInfoMutate({
                socialNetworksId: currentValue,
              })
            }}
            disabled={!currentValue || isLoadingSendNpsInfo}
          >
            {isLoadingSendNpsInfo ? <Loader /> : 'Enviar'}
          </Button>
        </div>
      )}
    </Modal>
  )
}

export default NpsMessage
